/**
 * `require.context` is a webpack builtin. Jest does not provide it, so a
 * module that calls it at import time throws the moment a test imports
 * anything downstream of it — which is what made the nav untestable.
 *
 * The loader is called rather than inspected so webpack can still see the
 * literal `require.context(...)` inside it and build the map at compile
 * time. Outside webpack the call throws and callers get an empty context,
 * so they render their empty state, which is correct in a test anyway.
 */
const EMPTY = Object.assign(() => null, { keys: () => [] });

export const assetContext = (loader) => {
  try {
    return loader();
  } catch {
    return EMPTY;
  }
};

export default assetContext;
